import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-975cc0a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fs-4 text-black fw-semibold mb-10 text-center" }, "Continuer la session", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, "Chargement des questions...", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "text-center"
}
const _hoisted_9 = { class: "alert alert-warning" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-10" }, "⚠️ Test déjà terminé", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-20" }, " Ce test est déjà terminé, impossible de le continuer. Toutes les questions ont déjà été répondues. ", -1))
const _hoisted_12 = { class: "d-flex justify-content-center gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "results-container"
}
const _hoisted_16 = { class: "" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-20" }, "Test Terminé !", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "row gx-2" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Score", -1))
const _hoisted_24 = { class: "fs-1 fw-bold text-success" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Pourcentage", -1))
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Bonnes réponses", -1))
const _hoisted_31 = { class: "fs-1 fw-bold text-success" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Mauvaises réponses", -1))
const _hoisted_35 = { class: "fs-1 fw-bold text-danger" }
const _hoisted_36 = { class: "text-start mt-10" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-15 text-center" }, "📋 Revue détaillée de vos réponses", -1))
const _hoisted_38 = { class: "questions-review" }
const _hoisted_39 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_40 = { class: "mb-0 fw-bold" }
const _hoisted_41 = { class: "question-number" }
const _hoisted_42 = { class: "question-content p-10 bg-white" }
const _hoisted_43 = { class: "fw-semibold mb-10 text-black" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-black" }, "Votre réponse :", -1))
const _hoisted_45 = {
  key: 0,
  class: "correct-answer-display p-10 bg-success-subtle rounded"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-success" }, "✓ Bonne réponse :", -1))
const _hoisted_47 = { class: "ms-2 text-success fw-bold" }
const _hoisted_48 = {
  class: "progress mb-20",
  style: {"height":"8px"}
}
const _hoisted_49 = {
  key: 0,
  class: "form-group mb-10"
}
const _hoisted_50 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_51 = { class: "alert alert-info" }
const _hoisted_52 = {
  key: 1,
  class: "form-group mb-10"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner une réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_54 = {
  key: 0,
  class: "border border-primary p-10"
}
const _hoisted_55 = { class: "d-flex align-items-center mb-5" }
const _hoisted_56 = ["for"]
const _hoisted_57 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_58 = {
  key: 2,
  class: "form-group mb-10"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Votre réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_60 = {
  key: 3,
  class: "form-group mb-10"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner une réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_62 = { class: "border border-primary p-10" }
const _hoisted_63 = { class: "d-flex align-items-center mb-5" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-black",
  for: "oui",
  style: {"cursor":"pointer"}
}, "Oui", -1))
const _hoisted_65 = { class: "d-flex align-items-center mb-5" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-black",
  for: "non",
  style: {"cursor":"pointer"}
}, "Non", -1))
const _hoisted_67 = { class: "d-flex align-items-center mt-10" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_71 = {
  key: 4,
  class: "mt-10"
}
const _hoisted_72 = { class: "text-danger" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = {
  key: 5,
  class: "mt-10"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle me-1" }),
  /*#__PURE__*/_createTextVNode(" Prêt à continuer ")
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 4,
  class: "text-danger text-center"
}
const _hoisted_78 = { class: "alert alert-danger" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Test impossible à continuer", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, " Aucune question n'est associée à cette session. ", -1))
const _hoisted_81 = { class: "d-flex justify-content-center gap-2" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_ctx.isTestCompleted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: "/liste-sessions",
                    class: "btn btn-secondary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(" Retour à la liste ")
                    ]),
                    _: 1
                  }),
                  (_ctx.sessionId)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'ViewSessionPage', params: { id: _ctx.sessionId } },
                        class: "btn btn-info"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _createTextVNode(" Voir les résultats ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_ctx.showResults)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      (_ctx.sessionId)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Session ID: " + _toDisplayString(_ctx.sessionId), 1))
                        : _createCommentVNode("", true),
                      (_ctx.sessionCode)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Code de la session: " + _toDisplayString(_ctx.sessionCode), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.testResults.score) + " / " + _toDisplayString(_ctx.testResults.total), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("p", {
                          class: _normalizeClass(["fs-1 fw-bold", _ctx.testResults.percentage >= 50 ? 'text-success' : 'text-danger'])
                        }, _toDisplayString(_ctx.testResults.percentage) + "% ", 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.testResults.correctAnswers), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.testResults.incorrectAnswers), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsWithAnswers, (question, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: question.id,
                          class: _normalizeClass(["question-review-item mb-15 border", question.isCorrect ? 'border-success' : 'border-danger'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["question-header p-5", question.isCorrect ? 'bg-success-subtle' : 'bg-danger-subtle'])
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("h5", _hoisted_40, [
                                _createElementVNode("span", _hoisted_41, "Question " + _toDisplayString(index + 1), 1)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["fs-3", question.isCorrect ? 'text-success' : 'text-danger'])
                              }, _toDisplayString(question.isCorrect ? '✓' : '✗'), 3)
                            ])
                          ], 2),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("p", _hoisted_43, _toDisplayString(question.contenu), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["user-answer mb-5 p-10 rounded", question.isCorrect ? 'bg-light' : 'bg-light'])
                            }, [
                              _hoisted_44,
                              _createElementVNode("span", {
                                class: _normalizeClass(["ms-2 fw-semibold", question.isCorrect ? 'text-success' : 'text-danger text-decoration-line-through'])
                              }, _toDisplayString(question.userAnswerText), 3)
                            ], 2),
                            (!question.isCorrect)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(question.correctAnswerText), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : (_ctx.questions.length > 0)
              ? (_openBlock(), _createBlock(_component_Form, {
                  key: 3,
                  ref: "testForm",
                  onSubmit: _ctx.handleSubmit,
                  "validation-schema": _ctx.testSchema
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", {
                        class: "progress-bar bg-success",
                        style: _normalizeStyle({ width: _ctx.progressPercentage + '%' })
                      }, null, 4)
                    ]),
                    (_ctx.currentQuestion)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("label", _hoisted_50, " Question " + _toDisplayString(_ctx.currentQuestionIndex + 1) + " / " + _toDisplayString(_ctx.questions.length), 1),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.currentQuestion.contenu), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentQuestion && _ctx.currentQuestion.type === 'choix_multiple')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _hoisted_53,
                          (_ctx.propositionOptions.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propositionOptions, (proposition, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `prop-${proposition.value}-${index}`
                                  }, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createVNode(_component_Field, {
                                        name: "answer",
                                        type: "radio",
                                        value: proposition.value,
                                        modelValue: _ctx.formData.answer,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                        id: `proposition-${proposition.value}`,
                                        class: "form-check-input me-2",
                                        onChange: _ctx.onAnswerChange
                                      }, null, 8, ["value", "modelValue", "id", "onChange"]),
                                      _createElementVNode("label", {
                                        class: "text-black",
                                        for: `proposition-${proposition.value}`,
                                        style: {"cursor":"pointer"}
                                      }, _toDisplayString(proposition.label), 9, _hoisted_56)
                                    ])
                                  ]))
                                }), 128)),
                                _createVNode(_component_ErrorMessage, {
                                  name: "answer",
                                  class: "text-danger"
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_57, " Aucune proposition disponible pour cette question. "))
                        ]))
                      : (_ctx.currentQuestion && _ctx.currentQuestion.type === 'texte_libre')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _hoisted_59,
                            _createVNode(_component_Field, {
                              name: "answer",
                              as: "textarea",
                              class: "form-control shadow-none text-black",
                              modelValue: _ctx.formData.answer,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.answer) = $event)),
                              placeholder: "Entrez votre réponse",
                              rows: "4",
                              onInput: _ctx.onAnswerChange
                            }, null, 8, ["modelValue", "onInput"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "answer",
                              class: "text-danger"
                            })
                          ]))
                        : (_ctx.currentQuestion && _ctx.currentQuestion.type === 'oui_non')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _hoisted_61,
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _createVNode(_component_Field, {
                                    name: "answer",
                                    type: "radio",
                                    value: "Oui",
                                    modelValue: _ctx.formData.answer,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                    id: "oui",
                                    class: "form-check-input me-2",
                                    onChange: _ctx.onAnswerChange
                                  }, null, 8, ["modelValue", "onChange"]),
                                  _hoisted_64
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_component_Field, {
                                    name: "answer",
                                    type: "radio",
                                    value: "Non",
                                    modelValue: _ctx.formData.answer,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                    id: "non",
                                    class: "form-check-input me-2",
                                    onChange: _ctx.onAnswerChange
                                  }, null, 8, ["modelValue", "onChange"]),
                                  _hoisted_66
                                ]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "answer",
                                  class: "text-danger"
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn btn-secondary me-3", { 'cursor-not-allowed': _ctx.currentQuestionIndex === 0 }]),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.previousQuestion && _ctx.previousQuestion(...args))),
                        disabled: _ctx.currentQuestionIndex === 0
                      }, " Précédent ", 10, _hoisted_68),
                      _createElementVNode("button", {
                        type: "submit",
                        class: _normalizeClass(["btn", [
              _ctx.isLastQuestion ? 'btn-success' : 'btn-info',
              { 'cursor-not-allowed': _ctx.isDisable }
            ]]),
                        disabled: _ctx.isDisable || _ctx.isSubmitting
                      }, [
                        (_ctx.isSubmitting)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_70))
                          : (_openBlock(), _createElementBlock("i", {
                              key: 1,
                              class: _normalizeClass(_ctx.isLastQuestion ? 'fa fa-check me-1' : 'fa fa-arrow-right me-1')
                            }, null, 2)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isLastQuestion ? 'Terminer le test' : 'Suivant'), 1)
                      ], 10, _hoisted_69)
                    ]),
                    (_ctx.isDisable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createElementVNode("small", _hoisted_72, [
                            (!_ctx.currentQuestion)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, "Aucune question disponible"))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _hoisted_80,
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_router_link, {
                        to: "/liste-sessions",
                        class: "btn btn-primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_82,
                          _createTextVNode(" Retour ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
    ])
  ]))
}